/**
 * sections/robust-contact-form.liquid: filters the "Product" <select>'s <optgroup>s down
 * to whichever collection is chosen in the "Collection" <select>, and runs the same
 * email-format check on submit as sections/contact-form.liquid's own inline script.
 */
;(function () {
	function initProductFilter(root) {
		var collectionSelect = root.querySelector('[data-robust-contact-form-collection]')
		var productSelect = root.querySelector('[data-robust-contact-form-product]')
		if (!collectionSelect || !productSelect) return
 
		// Keeping JS references to the original <optgroup> nodes and re-inserting only the
		// matching one (instead of leaving all of them in the DOM and toggling hidden/
		// disabled) is what makes this behave the same in every browser. hidden on an
		// <optgroup> removes it from Firefox's native dropdown, but Safari still renders it
		// — just grayed out — so a hidden-only approach looked "filtered" in one browser and
		// "everything, but some grayed out" in the other. Actually removing the non-matching
		// nodes from the select is unambiguous: there's nothing left for either browser to
		// render.
		var optgroups = Array.prototype.slice.call(productSelect.querySelectorAll('optgroup'))
		if (!optgroups.length) return
 
		function applyFilter() {
			var handle = collectionSelect.value

			optgroups.forEach(function (group) {
				group.remove()
			})

			optgroups.forEach(function (group) {
				if (!handle || group.getAttribute('data-collection-handle') === handle) {
					productSelect.appendChild(group)
				}
			})

			productSelect.value = ''
		}

		collectionSelect.addEventListener('change', applyFilter)
	}

	// The canonical 000-000-0000 shape is fully determined by how many digits have been
	// typed — dashes always belong after the 3rd and 6th digit, nowhere else. So rather
	// than trying to track a dash's exact typed position (which is what broke this the
	// first time: a dash typed before the 4th digit had nowhere valid to go yet, and just
	// got dropped, reading as "dashes don't work"), every keystroke strips everything down
	// to its digits and rebuilds the dashes from scratch at those two fixed points. A
	// self-typed dash still "does something" under this — it's simply absorbed into the
	// correctly-dashed result instead of literally landing where the keystroke happened.
	function formatPhoneNumber(value) {
		var digits = value.replace(/[^0-9]/g, '').slice(0, 10)
		var area = digits.slice(0, 3)
		var prefix = digits.slice(3, 6)
		var line = digits.slice(6, 10)
		if (digits.length > 6) return area + '-' + prefix + '-' + line
		if (digits.length > 3) return area + '-' + prefix
		return area
	}

	function initPhoneFormatting(root) {
		var inputs = root.querySelectorAll('[data-robust-contact-form-phone]')
		inputs.forEach(function (input) {
			function reformat() {
				var cursor = input.selectionStart
				var digitsBeforeCursor =
					cursor === null ? null : input.value.slice(0, cursor).replace(/[^0-9]/g, '').length
				var formatted = formatPhoneNumber(input.value)
				if (formatted === input.value) return
				input.value = formatted

				if (digitsBeforeCursor === null) return
				// Walk forward through the reformatted value until the same number of digits
				// the cursor was after has gone by, so it lands back in the same logical spot
				// instead of jumping to the end on every keystroke.
				var seen = 0
				var newPos = formatted.length
				for (var i = 0; i < formatted.length; i++) {
					if (/[0-9]/.test(formatted[i])) seen++
					if (seen === digitsBeforeCursor) {
						newPos = i + 1
						break
					}
				}
				input.setSelectionRange(newPos, newPos)
			}

			input.addEventListener('input', reformat)
			if (input.value) reformat()
		})
	}

	function initEmailValidation(form) {
		var emailInput = form.querySelector('input[type="email"]')
		var errorMsg = form.querySelector('[data-robust-contact-form-email-error]')
		if (!emailInput) return

		function isValidEmail(email) {
			return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
		}

		form.addEventListener('submit', function (event) {
			var email = emailInput.value.trim()
			if (isValidEmail(email)) {
				emailInput.removeAttribute('aria-invalid')
				if (errorMsg) errorMsg.hidden = true
				return
			}

			event.preventDefault()
			emailInput.setAttribute('aria-invalid', 'true')
			if (errorMsg) {
				errorMsg.hidden = false
				errorMsg.querySelector('.form__message').textContent =
					'Please enter a valid email address.'
			} else {
				alert('Please enter a valid email address.')
			}
		})
	}

	function initRobustContactForm(section) {
		if (section.dataset.initialized) return
		section.dataset.initialized = 'true'

		initProductFilter(section)
		initPhoneFormatting(section)

		var form = section.querySelector('.robust-contact-form__form')
		if (form) initEmailValidation(form)
	}

	function initAll(root) {
		;(root || document).querySelectorAll('.robust-contact-form').forEach(initRobustContactForm)
	}

	document.addEventListener('DOMContentLoaded', function () {
		initAll()
	})
	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target)
	})
	if (document.readyState !== 'loading') initAll()
})()
